import { io } from 'socket.io-client'
import { BACKEND_BASE_URL } from '../api'

export const spaceSocket = io(BACKEND_BASE_URL, {
  withCredentials: true,
  autoConnect: false,
})
